export const HINTS_URL = '';
export const HINTS_BASE_URL = '/HintsService/v1.0/rest/ecommerce/';

export const RECEIPT_SERVICE_URL = '/ReceiptService/v1.0';

export const RESTAURANT_ID = 1;

/* kiosk */
export const SCANBARCODE = false;
export const DISPENSOR_ENABLED = false;
export const ECOMMERCE = true;



// WEBPACK FOOTER //
// ./src/config/api.js